import { type Optional } from '@direct-frontend/stdlib';
import { type ImageInfo } from '../../api/image';
import { defaultMediaItem } from './defaultMediaItem';

export const getProductImage = (image: Optional<ImageInfo>) => image ?? defaultMediaItem;
